import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable, shareReplay, switchMap } from "rxjs";
import { Effort } from "../models/effort";
import { environment } from "../../environments/environment";
import { Project } from "../models/project";
import { FilterChip } from "../models/filter-chip";
import { BaseService } from "./base.service";

@Injectable({ providedIn: 'root' })
export class ProjectsService extends BaseService {
  private sortProperties: { [key: string]: string } = {
    "key": "Key", "title": "Title", "effortTitle": "Effort.Title", "oAccount": "OAccount", "mfk": "MFK", "customer": "Customer", "owner": "Owner", "members" : "NumMembers",
    "isHR": "Effort.IsHR"
  };

  createProject(proj: Project): Observable<Project> {
    const create = this.http.post<Project>(environment.apiUrl + 'projects', proj).pipe(shareReplay());
    create.subscribe(c => this.sourceUpdatedSubject.next(true));
    return create;
  }

  updateProject(proj: Project): Observable<Project> {
    const update = this.http.put<Project>(environment.apiUrl + `projects/${proj.id}`, proj).pipe(shareReplay());
    update.subscribe(c => this.sourceUpdatedSubject.next(true));
    return update;
  }

  deleteProject(proj: Project): Observable<Project> {
    const update = this.http.delete<Project>(environment.apiUrl + `projects/${proj.id}`).pipe(shareReplay());
    update.subscribe(c => this.sourceUpdatedSubject.next(true));
    return update;
  }

  private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
  sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

  private projectsSubject = new BehaviorSubject<Project[]>([]);
  projects$ = this.projectsSubject.asObservable();

  constructor(private http: HttpClient) {
    super();
  }

  fetchProjects(effortKey: string) {
    this.http.get<Project[]>(environment.apiUrl + 'projects/search').subscribe(projects => {
      this.projectsSubject.next(projects);
    });
  }

  filterProjects(filters: FilterChip[], pageSize: number = 10, pageIndex: number = 0, sorts: [string, string][] | undefined = undefined, shallow = true, includeHRWhenHasLeave = true) {
    return this.sourceUpdated$.pipe(
      switchMap(() => {
        const keywords = filters.filter(c => c.chip == null).reduce((v, c) => v + ' ' + c.value, '');
        const propertyValues = filters.reduce((v, c) => { if (c.chip != null) v[c.chip] = c.value; return v; }, <{ [key: string]: string }>{});
        const filter = <any>{ keywords, propertyValues };
        if (pageSize) filter['pageSize'] = '' + pageSize
        if (pageIndex) filter['page'] = '' + pageIndex;
        if (sorts) {
          sorts?.reduce((acc, [field, dir], i) => {
            acc[`SortSpecifications[${i}].Property`] = this.sortProperties[field];
            acc[`SortSpecifications[${i}].Direction`] = dir == "asc" ? "Ascending" : "Descending";
            return acc;
          }, filter);
        };
        const filterQuery = this.serialize(filter) + `&includeHRWhenHasLeave=${includeHRWhenHasLeave}`;
        return this.http.get<Project[]>(environment.apiUrl + `projects/${shallow ? 'shallow-' : ''}search?` + filterQuery, { observe: 'response' });
      }),
      map(response => {
        const paging = response.headers.get('Content-Range');
        const total = parseInt(paging?.split("/")[1] ?? '0');
        const projects = response.body ?? [];
        return { total, projects };
      })
    );
  }

  // addProject(newEffort: Effort) {
  //   console.log(newEffort, "soupa");
  //   this.http.post(environment.apiUrl + 'projects', newEffort).subscribe(() => {
  //     this.fetchProjects(); // Re-fetch projects after adding
  //   });
  // }

  // deleteEffort(effort: Effort) {
  //   this.http.delete(environment.apiUrl + `projects/${effort.id}`).subscribe(() => {
  //       this.fetchProjects();
  //   });
  // }
}

export class ProjectFilter {
  effortId?: number;
  title?: string;
}
